/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

// axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;
// window.axios.defaults.withXSRFToken = true;


// let token = document.querySelector('meta[name="csrf-token"]');

// if (token) {
//     axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// } else {
//     console.error('CSRF token non trovato: assicurati che sia nel tag <meta>.');
// }

export default axios;

/*
import {DymoServices, createImageWithText} from 'node-dymo-printer';
window.DymoServices = DymoServices;
window.createImageWithText = createImageWithText;
*/




/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });


/*

    @if(env('APP_ENV'))
        @viteReactRefresh
        @vite(['resources/css/app.css', 'resources/js/app.tsx'])
    @else
        @php
            $cwd = getcwd();
            $cssName = basename(glob($cwd . '/build/assets/*.css')[0], '.css');
            $jsName = basename(glob($cwd . '/build/assets/*.js')[0], '.js');
            $css = asset('build/assets/' . $cssName . '.css');
            $js = asset('build/assets/' . $jsName . '.js');
        @endphp

        <link rel="stylesheet" href="{{ $css }}" id="css">
        <script src="{{ $js }}" id="js"></script>
    @endif
*/